module.exports = __webpack_public_path__ + "img/01.bd7ed64b.png";